import { FormGroup } from '@angular/forms';
var TabLocationComponent = /** @class */ (function () {
    function TabLocationComponent() {
    }
    return TabLocationComponent;
}());
export { TabLocationComponent };
